/**
 * @file Pricing Card Toggle Dual
 */

/**
 * Pricing Card Toggle Dual component
 */
const vPricingCardToggleDual = () => {
	const headerToggles = document.querySelectorAll( '.v-pricing-card-toggle-dual__title' );
	const planContents 	= document.querySelectorAll( '.v-pricing-card-toggle-dual__content' );
	const plans 				= document.querySelectorAll( '.v-pricing-card-toggle-dual' );

	if ( ! headerToggles ) {
		return;
	}

	[ ...plans ].forEach( ( plan ) => {
		const headers = plan.querySelectorAll( '.v-pricing-card-toggle-dual__title' );
		[ ...headers ].forEach( ( header, key ) => {
			header.addEventListener( 'click', ( e ) => {
				e.preventDefault();

				const planContent = header.parentElement.parentElement.querySelector( `.v-pricing-card-toggle-dual__content-${ key }` );
				const defaultTier = planContent.querySelector( '.v-pricing-card-toggle__toggle' );
				defaultTier.click();

				[ ...headers ].forEach( ( h ) => h.classList.remove( 'selected' ) );
				[ ...planContents ].forEach( ( p ) => p.classList.remove( 'selected' ) );

				header.classList.add( 'selected' );
				planContent.classList.add( 'selected' );
			} );
		} );
	} );
};

export default vPricingCardToggleDual;
